export enum ShopActEnum {
  INFORMATION = "@shop/INFORMATION",
  DESCRIPTOR = "@shop/DESCRIPTOR",
}
